import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import ViewTable from './ViewTable';
import { fetchAppointmentView } from 'slices/appointmentSlice';
import { useDispatch, useSelector } from 'react-redux';
import { SubmitButton } from 'components/common/buttons/SubmitButton';
import toast from 'react-hot-toast';
import { setActionAssign } from 'slices/actionButtonSlice';
import CancelModal from 'components/appointment/CancelModal';
import DonotCover from 'components/appointment/DonotCover';
import RescheduleModal from 'components/appointment/RescheduleModal';
import { fetchAppointmentLogs } from 'slices/appointmentSlice';
import { Table } from 'reactstrap';
import LogsTable from './LogsTable';
import AddAppointment from 'components/appointment/AddAppointment';
import { setAddAppointmentPopup } from 'slices/appointmentSlice';
import { appointmentsSelector } from 'slices/appointmentSlice';
import { closeAppointmentPopup } from 'slices/appointmentSlice';
import EditAppointment from 'components/appointment/EditAppointment';
import { removeAppointment } from 'slices/appointmentSlice';
import Swal from 'sweetalert2';
import SelectInterpreterModal from 'components/common/SelectInterpreterModal';
import CouldNotCover from 'components/appointment/CouldNotCover';
import CopyAppointment from 'components/appointment/CopyAppointment';
import FullPageLoader from 'components/common/FullPageLoader';
import RecordingModal from 'views/JoinRoomCall/RecordingModal';
import { fetchMainAccountAppointmentLogs } from 'slices/mainAccount/mainAccountAppointmentSlice';
import { fetchMainAccountAppointmentView } from 'slices/mainAccount/mainAccountAppointmentSlice';
import { mainAccountAppointmentsSelector } from 'slices/mainAccount/mainAccountAppointmentSlice';
import moment from 'moment-timezone';
import { usePermissions } from 'layouts/Admin';
import { useTranslation } from 'react-i18next';
const AppointmentView = () => {
    const { t } = useTranslation();
    const { id } = useParams();
    const navigate = useNavigate();
    const { checkPermission } = usePermissions()
    const dispatch = useDispatch();

    const [item, setItem] = React.useState({});
    const [loading, setLoading] = React.useState(false)
    const [logs, setLogs] = React.useState([]);
    const [cancelModal, setCancelModal] = React.useState(false);
    const [recordingUrl, setRecordingUrl] = React.useState(null);
    const [showRecordingModal, setShowRecordingModal] = React.useState(false);

    const showRecordingPopup = () => {
        if (item?.appointment_details?.recording) {
            setRecordingUrl(item.appointment_details.recording);
            setShowRecordingModal(true);
        } else {
            toast.error(t("appointmentView.recordingUnavailable"), {
                className: "errorToast",
            });
        }
    };

    const callViewApi = async () => {
        const callBack = (success, message, data) => {
            setLoading(false);
            if (success) {
                setItem(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
        }

        dispatch(fetchMainAccountAppointmentView(id, callBack))
    };

    const fetchLogs = async () => {
        const callBack = (success, message, data) => {
            if (success) {
                setLogs(data)
                console.log(data)
            }
            else {
                console.log(message)
            }
            // setLogs()
        }
        dispatch(fetchMainAccountAppointmentLogs(id, callBack))
    }

    React.useEffect(() => {
        setLoading(true)
        callViewApi();
        fetchLogs();

    }, [id]);

    const handleCancel = () => {
        setCancelModal(true);
    };
    const handleCloseCancel = () => {
        setCancelModal(false);
    };

        const handleSubmit = (data, end_point, callBack) => {
        setLoading(true)
        const submitCallback = (success, message) => {
            callBack && callBack()
            if (success) {
                handleCloseCancel();
                callViewApi();
                fetchLogs()
                toast.success(message, {
                    className: "successToast",
                });
                setLoading(false)
                // scheduleDetailModal?.show && openModal()
            }
            else {
                toast.error(message,
                    {
                        className: "errorToast",
                    }
                );
                setLoading(false)
            }
        }
        dispatch(
            setActionAssign(
                id,
                data,
                end_point,
                submitCallback
            )
        )
    }
    
    const ClientTimezone = item?.accounts?.timezone;
    const AppointmentTimezone = item?.appointment_details?.timezone;
    const rawDatetime = item?.datetime;

    // Date: use appointment timezone so late-night appointments don't shift the date
    const formattedDate = AppointmentTimezone?.name
      ? moment.tz(rawDatetime, AppointmentTimezone.name).format('MMM D, YYYY')
      : moment(rawDatetime).format('MMM D, YYYY');

    // Time: parse stored datetime as appointment timezone and label it
    const formattedClientTime = (() => {
      if (!AppointmentTimezone?.name) return moment(rawDatetime).format('hh:mm A');
      const m = moment.tz(rawDatetime, AppointmentTimezone.name).tz(ClientTimezone.name);
    //   const abbr = ClientTimezone.abbreviation;
    //   const offset = ClientTimezone.utc_offset;
    //   const zone = abbr ? `(${abbr} / GMT${offset})` : `(GMT${offset})`;
      const dynamicAbbr = m.format("z");
      const dynamicOffset = m.format("Z");
    
      const zone = dynamicAbbr ? `(${dynamicAbbr} / GMT${dynamicOffset})` : `(GMT${dynamicOffset})`;
      return `${m.format('hh:mm A')} ${zone}`;
    })();
    

    return (
        <div className="content" style={{}}>
            {loading && <FullPageLoader  />}
            <div className="row_main_head bg-primary-secondaryCard">
                <h2 className={`main_heading main_heading1`}>{t("appointmentDetail.viewAppointmentHeading", { defaultValue: "View Appointment #" })} {item?.appid}</h2>
                <div className='mb-3'>
                    <div className='text-transform-capitalize main_heading main_heading1' >
                        {t("appointmentDetail.client", { defaultValue: "Client" })} : {item?.accounts?.user?.name}
                    </div>
                </div>
            </div>
            <div className="row_main_head bg-light-secondaryCard mt-3">
                <h2 className={`main_heading2`} toLowerCase={'text-lowercase'}>{t("table.date", { defaultValue: "Date" })} <span className="dateTime">{formattedDate}</span> <span className="dateTime">{formattedClientTime}</span></h2>
                <div className='mb-3'>
                    <div className='text-transform-capitalize main_heading2' >
                    <span className="appointmentType">{item?.type}</span> <span className="appLanguage">{item?.language?.name}</span>
                    </div>
                </div>
            </div>
            <div className="card_table view_table_custom">


                <div className='row-primary flex-wrap'>
                    {( item?.status !== "cancelled" && item?.status !== "completed") && <SubmitButton buttonType="button" className={'tomatoRed'} btnText={t("common.cancel", { defaultValue: "Cancel" })} handleSubmit={handleCancel} />}
                    {item?.appointment_details?.recording && (
                        <SubmitButton
                            buttonType="button"
                            className="Cancle_button"
                            btnText={t("appointmentView.viewRecording")}
                            handleSubmit={showRecordingPopup}
                        />
                    )}
                </div>

                <ViewTable item={item} />

                <CancelModal
                    isOpen={cancelModal}
                    onClose={handleCloseCancel}
                    onConfirm={handleSubmit}
                    appointmentId={id}
                    item={item}
                    loader={loading}
                />
                <RecordingModal
                    recordingUrl={recordingUrl}
                    showModal={showRecordingModal}
                    onClose={() => setShowRecordingModal(false)}
                />
            </div>

            <div className="card_table p-4">
                <div className="row_main_head mb-3">
                    <h2 className={`main_heading`}>{t("appointmentDetail.appointmentLogs", { defaultValue: "Appointment Logs" })}</h2>
                </div>
                <LogsTable logs={logs} />
            </div>
        </div>
    )
}





export default AppointmentView